module.exports = __webpack_public_path__ + "img/map-report-usage-guide-imp.b80803ff.png";